import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component } from '@angular/core';
import { PalantirPageComponent } from '../page/page.component';

@Component({
  selector: 'palantir-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirModalComponent {}
